// import { useEffect, useState } from "react";
// import { useParams } from "react-router";
// import React from 'react';
// import Api from "../../Api/Api";
// import { username } from "../../API";

// import NavBar from "../Navbar";
// import { Row, Col, Card } from "react-bootstrap";
// import { Link } from "react-router-dom";
// import { ToastContainer } from "react-toastify";
// import { toastSuccess, toastWarning } from "../../utilis/toast.js"

import { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
import React from "react";
import Api from "../../Api/Api";
import NavBar from "../Navbar";
import { ToastContainer } from "react-toastify";
import { Link, useHistory, useLocation } from "react-router-dom";


import {
  Row,
  Col,
  Modal,
  Button,
  Form,
  // ToastContainer,
} from "react-bootstrap";
import { toastSuccess, toastWarning } from "../../utilis/toast.js";

const Profile = () => {
  const history = useHistory();

  const [client, setClient] = useState(null);
  const [edit, setEdit] = useState(false);
  const [email, setEmail] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  // const navigate = useNavigate();

  const getData = async () => {
    const { data } = await Api.getClient();
    setClient(data);
    setEmail(data.email);
    setFirstName(data.firstName);
    setLastName(data.lastName);
  };

  useEffect(() => {
    getData();
  }, []);

  const handleUpdateProfile = async () => {
    try {
      await Api.updateClient(email, firstName, lastName);
      toastSuccess(`Profile Updated Successfully`);
      setEdit(false);
      getData();
    } catch (e) {
      console.error(e);
      toastWarning(`Unable to update profile`);
      setEdit(false);
    }
  };

  // const handleChangePassword = async () => {
  //   if (newPassword !== confirmPassword) {
  //     toastWarning("Passwords do not match!");
  //     return;
  //   }
  //   try {
  //     await Api.changePassword(currentPassword, newPassword);
  //     toastSuccess("Password updated successfully");
  //     setShowPasswordModal(false);
  //   } catch (e) {
  //     console.error(e);
  //     toastWarning("Failed to change password");
  //   }
  // };

  // const handleLogout = () => {
  //   localStorage.clear();
  //   toastSuccess(`Logged out successfully`);
  //   history.push(`/login`);
  //   // window.location.reload();

  // };

  const handleLogout = () => {
    // Remove only authentication-related keys from localStorage
    localStorage.removeItem("auth");
    localStorage.removeItem("payment");

    // Display a success toast message
    toastSuccess("Logged out successfully");

    // Redirect the user to the login page
    history.push("/login");
    window.location.reload();
  };



  const handleChangePassword = (e) => {
    history.push(`/changepassword`);

  };


  return (
    <>
      <NavBar />
      {client && (
        <div className="text-center w-100" style={{ position: "absolute", top: "25%" }}>
          {!edit && (
            <div className="mx-5">
              <h3 className="text-white mb-3" style={{ textShadow: "1px 1px 1px black" }}>
                <span className="text-info">Name: </span>&nbsp; {client.firstName} {client.lastName}
              </h3>
              <h5 className="text-white mb-3" style={{ textShadow: "1px 1px 1px black" }}>
                <span className="text-info">Email:</span>&nbsp;&nbsp;{client.email}
              </h5>
              <div className="mt-2">
                <button onClick={() => setEdit(true)} className="btn btn-success me-3">Edit</button>
                {/* <button onClick={() => setShowPasswordModal(true)} className="btn btn-warning me-3">Change Password</button> */}
                <button onClick={(e) => handleChangePassword(e)} className="btn btn-warning me-3">Change Password</button>

                <button onClick={(e) => handleLogout(e)} className="btn btn-danger">Logout</button>
              </div>
            </div>
          )}

          {edit && (
            <div className="mx-5">
              <div className="d-flex justify-content-center">
                <h5 className="text-white mb-3 me-2" style={{ textShadow: "1px 1px 1px black" }}>
                  <span className="text-info">First Name: </span>&nbsp;
                  <input value={firstName} onChange={(e) => setFirstName(e.target.value)} />
                </h5>
                <h5 className="text-white mb-3" style={{ textShadow: "1px 1px 1px black" }}>
                  <span className="text-info">Last Name: </span>&nbsp;
                  <input value={lastName} onChange={(e) => setLastName(e.target.value)} />
                </h5>
              </div>
              <h5 className="text-white mb-3" style={{ textShadow: "1px 1px 1px black" }}>
                <span className="text-info">Email: </span>&nbsp;
                <input value={email} onChange={(e) => setEmail(e.target.value)} />
              </h5>
              <div className="mt-2">
                <button onClick={() => setEdit(false)} className="btn btn-danger me-4">Cancel</button>
                <button onClick={handleUpdateProfile} className="btn btn-success">Save</button>
              </div>
            </div>
          )}

          <ToastContainer position="top-right" autoClose={2000} />
        </div>
      )}

      {/* Change Password Modal
      <Modal show={showPasswordModal} onHide={() => setShowPasswordModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Change Password</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Current Password</Form.Label>
              <Form.Control
                type="password"
                value={currentPassword}
                onChange={(e) => setCurrentPassword(e.target.value)}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>New Password</Form.Label>
              <Form.Control
                type="password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Confirm New Password</Form.Label>
              <Form.Control
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowPasswordModal(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleChangePassword}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal> */}
    </>
  );
};

export default Profile;
